import { Injectable, Output, EventEmitter } from '@angular/core';
import { Subscription, interval } from 'rxjs';

@Injectable()
export class GlobalIntervalService {

    GlobalInterval: Subscription = null;

    @Output() _1SecondTick = new EventEmitter();
    @Output() _2SecondTick = new EventEmitter();
    @Output() _3SecondTick = new EventEmitter();
    @Output() _4SecondTick = new EventEmitter();
    @Output() _5SecondTick = new EventEmitter();

    constructor() {
        if (this.GlobalInterval === null) {
            this.GlobalInterval = interval(1000).subscribe((x) => {

                this._1SecondTick.emit();

                var second = new Date().getSeconds();

                if (second % 2 === 0)
                    this._2SecondTick.emit();

                if (second % 3 === 0)
                    this._3SecondTick.emit();

                if (second % 4 === 0) 
                    this._4SecondTick.emit();

                if (second % 5 === 0)
                    this._5SecondTick.emit();
            });
        }
    }
}